import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=64d9f9bb&scoped=true&"
import script from "./LinkInput.vue?vue&type=script&lang=js&"
export * from "./LinkInput.vue?vue&type=script&lang=js&"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=64d9f9bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9f9bb",
  null
  
)

export default component.exports